<template>
  <v-container
    id="inventoriesList"
    fluid
    tag="section"
    class="full-height"
  >
    <base-v-component
      heading="Инвентаризации"
    />

    <v-row class="mt-10 d-print-none">
      <v-col cols="12" class="text-right">
        <v-btn
          class="primary px-5"
          @click="newInventory"
        >
          <v-icon
            left
            dark
          >
            mdi-plus
          </v-icon>
          Нова инвентаризация
        </v-btn>
      </v-col>
    </v-row>
    
    <filter-inventories
      ref="inventoriesFilter"
      @doFilter="getData"
    />

    <base-material-card
      hover-reveal
      color="primary"
      icon="mdi-clipboard-check-multiple-outline"
      inline
      class="px-5 py-5 mt-15"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light"></div>
      </template>

      <v-divider class="mt-3 mb-6" />
      
      <base-data-table 
        :headers="table.headers" 
        :pagination="table.pagination" 
        :data="table.data" 
        :sortBy.sync="table.sortBy"
        :sortDesc.sync="table.sortDesc" 
        @getData="getData" 
        @doAction="doAction"
      />
    </base-material-card>
  </v-container>
</template>

<script>
import { filterInventories } from "@/components";
import { getInventories } from '@/api/inventories';

export default {
  name: 'inventoriesList',
  components: {
    filterInventories
  },
  data: () => ({
    table: {
      headers: [
        { text: 'Дата', value: 'date', valueType: "date" },
        { text: 'Наименование', value: 'name', valueType: "text" },
        { text: 'Общо артикули', value: 'countImported', valueType: "text" },
        { text: 'Брой намерени артикули', value: 'countFound', valueType: "text" },
        { text: 'Брой липсващи артикули', value: 'countMissing', valueType: "text" },
        { text: 'Приключена', value: 'isFinished', valueType: "status", align: 'center', class: 'text-center', active: 1, notActive: 0, statusIcons: true, activeClass: 'fw600 success--text', notActiveClass: 'fw600 error--text' },
        {
          sortable: false,
          text: '',
          value: '',
          valueType: 'button',
          style: "width: 50px;",
          class: 'text-right',
          buttons: [
            {
              label: 'Преглед',
              title: 'Преглед',
              icon: 'mdi-text-box-search-outline',
              size: 'small',
              class: 'primary',
              click: 'previewInventory',
            }
          ]
        },
      ],
      data: [],
      pagination: {
        itemsPerPage: 10,
        page: 1,
        perPageOptions: [5, 10, 25, 50, 100],
        total: 0
      },
      sortBy: 'date',
      sortDesc: true,
    }
  }),
  mounted(){
    this.getData();
  },
  methods: {
    getData(){
      let query = Object.assign({}, this.$refs.inventoriesFilter.filters);
      if(!query.page) query.page = this.table.pagination.page;
      query.itemsPerPage = this.table.pagination.itemsPerPage;
      query.sortBy = this.table.sortBy;
      query.sortDesc = this.table.sortDesc;
      getInventories(query).then(data => {
        this.table.data = data.Items;
        this.table.pagination.total = data.Total;
        this.table.pagination.page = query.page;
      })
    },
    doAction(actionData) {
      switch(actionData.action){
        case 'previewInventory':
          this.$router.push({path: `/inventories/${actionData.item._id}`})
        break;
      }
    },
    newInventory(){
      this.$router.push({path: `/inventories/create`});
    }
  }
}
</script>
